module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-tokai-3-cb1e616e13ba41fbf3c3827974f044d0.png";